module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-7-c8b2c2184ca450585a7a43a1bf6fea49.png";